export default __webpack_public_path__ + "static/media/Selo ISO 31000.2835d2a7.png";